import PropTypes from 'prop-types';
import React from 'react';
import { branch, renderNothing } from 'recompose';
import { timeShape } from '../../shapes';
import TimeSlot from './TimeSlot';

const renderIfTimes = noTimes =>
  branch(
    noTimes,
    renderNothing
  );
const enhance = renderIfTimes(props => props.times.length === 0);

const TimeGrid = ({ times, timezone, selectedTime, setTime }) => (
  <div className="c-time-grid">
    { times.map(item => (
      <TimeSlot
        key={item.time}
        item={item}
        timezone={timezone}
        selectedTime={selectedTime}
        setTime={setTime}
      />
    )) }
  </div>
);

TimeGrid.propTypes = {
  times: PropTypes.arrayOf(timeShape),
  timezone: PropTypes.string,
  selectedTime: PropTypes.string,
  setTime: PropTypes.func.isRequired,
};
TimeGrid.defaultProps = {
  timezone: null,
  times: [],
  selectedTime: null,
};

export default enhance(TimeGrid);



// WEBPACK FOOTER //
// ./src/app/times/components/TimeGrid.jsx